import * as L from "leaflet";

const maxZoom: number = 20;

export default class LeafletMapOSM {

    attribution: string;
    maxZoom: number;

    constructor(context: any) {
        this.attribution = context.attribution ?? '&copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors';
        this.maxZoom = context.maxZoom ?? maxZoom;
    }

    GetMapLayer(): L.TileLayer {
        let osmLayer: L.TileLayer = L.tileLayer('https://a.tile.openstreetmap.org/{z}/{x}/{y}.png?access_token=null', {
            id: "openstreetmap",
            attribution: this.attribution,
            maxZoom: this.maxZoom
        });
        return osmLayer;
    }
}